export default {"src":"https://images-cdn.curipod.com/d-fc5ed57c/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};